import React from "react"

export default function ProhibitedBusinessVerticalsIcon() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={30} height={30} viewBox="0 0 28 32" fill="none">
			<path
				fill="#000"
				fillRule="evenodd"
				d="M8.364 1a1 1 0 0 0-1 1v3.545H2a1 1 0 0 0-1 1v8.182a1 1 0 0 0 .91.996V22a1 1 0 0 0 1 1h18.18a1 1 0 0 0 1-1v-6.277a1 1 0 0 0 .91-.996V6.545a1 1 0 0 0-1-1h-5.364V2a1 1 0 0 0-1-1H8.364Zm6.272 4.545V3H9.364v2.545h5.272ZM3.91 21v-5.273h5.273v.819a1 1 0 0 0 1 1h3.636a1 1 0 0 0 1-1v-.819h5.273V21H3.909Zm5.273-8.09v.817H3V7.545h18v6.182h-6.182v-.818a1 1 0 0 0-1-1h-3.636a1 1 0 0 0-1 1Zm2 1v1.636h1.636v-1.637h-1.636Z"
				clipRule="evenodd"
			/>
			<circle cx={19.095} cy={23.095} r={7.594} fill="#FF506F" stroke="#fff" />
			<path fill="#fff" d="M15.219 22.492h7.804v1.419h-7.804z" />
		</svg>
	)
}
